<div class="position-reletivediv popup-inner-space Add-user-form">
    <div class="betweenheader">
        Schedule Report
    </div>

    <div class="text-right flow-right">
        <img src="assets/images/close.svg" alt="..." class="img-fluid closeicon2 cursor-pointer" (click)="Close()" />
    </div>
    <div class="popup-inner-space">
        <div class="errmsg error-register" *ngIf="errorMsg">{{ errorMsg }}</div>
        <div class="sucessmsg error-register" *ngIf="successMsg">
            {{ successMsg }}
        </div>
    </div>
</div>
<div class="filter-wrapper User-form padding-top-10 margin-top-15">
    <div class="col-md-12 pad_0_over filter-content">
        <div>
            <form [formGroup]="schedulereportForm" class="add-user-form-id" id="schedulereportForm">
                <ng-container>
                    <div class="d-flex user-lbl1">
                        <div class="col-lg-3">
                            <mat-form-field style="display: block">
                                <mat-select formControlName="SiteId" (selectionChange)="OnChangeSite($event)">
                                  <mat-option value="">(Select Customer)</mat-option>
                                  <mat-option MatFormFieldControl="SiteId" *ngFor="let lstsite of SiteList" [value]="lstsite.CodeValue">
                                    {{ lstsite.CodeDisplayText }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              <div class="error_msg" *ngIf="displayMessage.SiteId">
                                {{ displayMessage["SiteId"] }}
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <mat-form-field style="display: block">
                                <mat-form-field style="display: block" title="Panel Name">
                                  <mat-select formControlName="PanelId" (selectionChange)="OnChangePanel($event)">
                                    <mat-option value="">(Select Location)</mat-option>
                                    <mat-option MatFormFieldControl="PanelId" *ngFor="let lstpanel of PanelList"
                                      [value]="lstpanel.CodeValue">
                                      {{ lstpanel.CodeDisplayText }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                            </mat-form-field>
                            <div class="error_msg" *ngIf="displayMessage.PanelId">
                                {{ displayMessage["PanelId"] }}
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <mat-form-field style="display: block">
                                <mat-select formControlName="DeviceId" (selectionChange)="OnChangeDeviceId($event)">
                                  <mat-option value="">(Select Meter)</mat-option>
                                  <mat-option MatFormFieldControl="DeviceId" *ngFor="let lstdevice of DeviceList"
                                    [value]="lstdevice.CodeValue">
                                    {{ lstdevice.CodeDisplayText }}
                                  </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="error_msg" *ngIf="displayMessage.DeviceId">
                                {{ displayMessage["DeviceId"] }}
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <mat-form-field style="display: block">
                                <mat-select formControlName="DataType" (selectionChange)="OnChangeDataType($event)">
                                  <mat-option value="">(Select Data Type)</mat-option>
                                  <mat-option value="BatchData">Batch Data</mat-option>
                                  <mat-option value="RawData">Raw Data</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="error_msg" *ngIf="displayMessage.DataType">
                                {{ displayMessage["DataType"] }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex user-lbl1 padding-top-20">                       
                        <div class="col-lg-2">
                            <div class="fxg-field fxg-field2">
                                <mat-form-field class="display-block width100" title="Schedule Type">
                                    <mat-select formControlName="ScheduleType"
                                        (selectionChange)="OnChangeScheduleType($event)">
                                        <mat-option value="">(Select Schedule Type)</mat-option>
                                        <mat-option value="Daily">Daily</mat-option>
                                        <mat-option value="Weekly">Weekly</mat-option>
                                        <mat-option value="Monthly">Monthly</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="error_msg" *ngIf="displayMessage.ScheduleType">
                                    {{ displayMessage["ScheduleType"] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="fxg-field fxg-field2">
                                <mat-form-field class="calendar font13" appearance="fill">
                                    <mat-label><span class="margin-left-0px margin-top-0px">Email Time</span>
                                    </mat-label>
                                    <input matTimepicker #schedulereporttimepicker="matTimepicker" [strict]="false"
                                        class="margin-left-0px font-size-13 schduelreport-mat-input-element" id="timepicker-example" mode="24h"
                                        formControlName="EmailTime" placeholder="Please select time..." name="EmailTime"
                                        type="text" required (timeChange)="timeChangeHandler($event)">
                                </mat-form-field>
                                <div class="error_msg" *ngIf="displayMessage.EmailTime">
                                    {{ displayMessage["EmailTime"] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2" *ngIf="dayspanflag==true">
                            <div class="fxg-field fxg-field2">
                                <mat-form-field class="display-block width100" title="Day Span">
                                    <mat-select formControlName="DaySpan" (selectionChange)="OnChangeDaySpan($event)">
                                        <mat-option selected MatFormFieldControl="DaySpan" value="">(Select Day Span)
                                        </mat-option>
                                        <mat-option value="0">Today</mat-option>
                                        <mat-option value="1">1 Day</mat-option>
                                        <mat-option value="2">2 Day</mat-option>
                                        <mat-option value="3">3 Day</mat-option>
                                        <mat-option value="4">4 Day</mat-option>
                                        <mat-option value="5">5 Day</mat-option>
                                        <mat-option value="6">6 Day</mat-option>
                                    </mat-select>
                                </mat-form-field>                                
                            </div>
                        </div>
                        <div class="col-lg-2" *ngIf="emaildayflag==true">
                            <div class="fxg-field fxg-field2">
                                <mat-form-field class="display-block width100" title="Data Type">
                                    <mat-select formControlName="EmailDay" (selectionChange)="OnChangeEmailDay($event)">
                                        <mat-option value="selection" MatFormFieldControl="EmailDay">(Select Email Day)
                                        </mat-option>
                                        <mat-option value="Sunday">Sunday</mat-option>
                                        <mat-option value="Monday">Monday</mat-option>
                                        <mat-option value="Tuesday">Tuesday</mat-option>
                                        <mat-option value="Wednesday">Wednesday</mat-option>
                                        <mat-option value="Thursday">Thursday</mat-option>
                                        <mat-option value="Friday">Friday</mat-option>
                                        <mat-option value="Saturday">Saturday</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="error_msg" *ngIf="displayMessage.EmailDay">
                                    {{ displayMessage["EmailDay"] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2" *ngIf="emaildateflag == true">
                            <div class="fxg-field fxg-field2">
                                <mat-form-field class="display-block width100" title="Day Span">
                                    <mat-select formControlName="EmailDate"
                                        (selectionChange)="OnChangeEmailDate($event)">
                                        <mat-option value="" MatFormFieldControl="EmailDate">(Select Email Date)
                                        </mat-option>
                                        <mat-option *ngFor="let day of dateOptions" [value]="day">{{ day }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="fxg-field fxg-field2">
                                <input formControlName="EmailIds" id="EmailIds" type="text"
                                    class="fxg-field__input-text fxg-field__input--required sessioncamexclude">
                                <span class="fxg-field__placeholder fxg-field__floating-placeholder custom-placeholder"
                                    tabindex="-1">Email Ids</span>
                                <div class="error_msg" *ngIf="displayMessage.EmailIds">
                                    {{displayMessage["EmailIds"]}}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="fxg-field fxg-field2">
                                <button class="btncommon search-usermater minwidth100" id="SearchusermasterSearch"
                                    (click)="AddScheduleReportData()">Add</button>
                            </div>
                        </div>
                    </div>                   
                </ng-container>
            </form>
        </div>
    </div>
</div>
<div class="table-scroll-newsite tableBR margin-left-5">
    <table class="table table-layout-fixed tblschedulereport">
        <thead class="companytable thead-data td-data-main">
            <tr class="tr-padding">
                <th class="width-5">No.</th>
                <th class="width-25">Customer Name</th>
                <th class="width-25">Meter Name</th>
                <th class="width-25">Schedule Type</th>
                <th class="width-25">Day Span</th>
                <th class="width-25">Email Time</th>
                <th class="width-25">Email Day</th>
                <th class="width-25">Email Date</th>
                <th class="width-25">Email Ids</th>
                <th class="width10 text-right">Action</th>
            </tr>
        </thead>
        <tbody class="table-responsive-sechedule">
            <tr *ngFor="let data of ScheduleReportList; let i = index" class="height0">
                <td class="width-5">{{i+1}}</td>
                <th class="width-25">{{data.CustomerName}}</th>    
                <th class="width-25">{{data.MeterName}}</th>                
                <th class="width-25">{{data.ScheduleType}}</th>
                <th class="width-25">{{data.DaySpan}}</th>
                <td class="width-25">{{data.EmailTime}}</td>
                <td class="width-25">{{data.EmailDay}}</td>
                <td class="width-25">{{data.EmailDate}}</td>
                <td class="width-25 table-td" [title]="data.EmailIds">
                    {{data.EmailIds}}
                </td>
                <td class="width10 text-right">
                    <img src="assets/images/delete.svg" alt="..."
                        class="img-fluid closeicon2 cursor-pointer"
                        (click)="DeleteScheduleReportData(i, data.ScheduleReportId)" id="delete_icon">
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="margin-top-5 d-flex justify-content-end add-user-btn">
    <div class="text-right">
        <button type="submit" class="btncommon" id="SearchusermasterSearch" (click)="SaveScheduleReportData()">
            Save
        </button>
    </div>
</div>